import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUserInfo, clearUserInfo } from './state';

export default function AppInitializer() {
  const dispatch = useDispatch();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/profile`, { credentials: 'include' })
      .then((res) => {
        if (!res.ok) throw new Error('Not logged in');
        return res.json();
      })
      .then((user) => dispatch(setUserInfo(user)))
      .catch(() => dispatch(clearUserInfo()));
  }, [dispatch]);

  return null;
}
